import { useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ConfigurableFormProvider, CrfForm, useForm } from '@pihealth/common-ui-library';
import { QueryClient } from '@tanstack/react-query';
import { forwardRef, useImperativeHandle, useState } from 'react';
import apiConfig from 'src/api/APIConfig';
import { useAppSelector } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError(error: unknown) {
        console.error(error);
      }
    },
    mutations: {
      onError(error: unknown) {
        console.error(error);
      }
    }
  }
});

// eslint-disable-next-line react/display-name
const DJ2Form = forwardRef((props: any, ref) => {
  const [crfForm, setCrfForm] = useState<any>({
    type: 'ce',
    file_data: props.initialValues?.file_data ? props.initialValues?.file_data : [],
    event_uuid: props.initialValues?.event_uuid ? props.initialValues?.event_uuid : null
  });
  const user: any = useAppSelector(state => state.user?.user);
  const theme = useTheme();
  const { userPreferedDateFormat } = usePreferedDateFormat();

  const onChange = (event: any, fieldConfig: any) => {
    setCrfForm(event);
    props.SetchangedData({ ...props.initialValues, ...event });
    props?.onChange(event, fieldConfig);
  };

  const { handleSubmit, handleReset } = useForm({
    initialValues: props.initialValues,
    rules: props.rules || {},
    onChange: props.onChange,
    onBlur: props.onBlur,
    isCustomForm: true
  });

  useImperativeHandle(ref, () => ({
    submit: (callback: any) => {
      handleSubmit(callback);
    },
    reset: () => {
      handleReset();
    }
  }));

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ConfigurableFormProvider
        apiBaseUrl={`${apiConfig.appConfig.apisysadmin}` as any}
        ctmsApiBaseUrl={`${apiConfig.appConfig.apictms}` as any}
        queryClient={queryClient as any}
        sessionId={user.sessionId}
        token={user.sponsorToken}
        sponsor={user.sponsor_sponsor_name}
        site_token={user.siteToken}
      >
        <div>
          <CrfForm
            crf={crfForm}
            isReadOnly={props.isReadOnly}
            onChange={onChange}
            formConfig={props.formConfig}
            theme={theme}
            sectionMetadata={props?.formConfig?.sectionMetadata ? props?.formConfig?.sectionMetadata : null}
            dateFormat={userPreferedDateFormat}
            updateFormConfig={props?.updateFormConfig}
            previewIn={props.isReadOnly ? 'TSDASUBTOOLKIT' : 'TSDAASSIGNMENT'}
          />
        </div>
      </ConfigurableFormProvider>
    </LocalizationProvider>
  );
});

export default DJ2Form;
